module.exports = require('../src/index.js')



// WEBPACK FOOTER //
// ./build/prod.js